import { OnInit, ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Pbx } from "@onsip/web/features/accountSettings/transfer-numbers/transfer-numbers.component";

@Component({
  selector: "onsip-transfer-numbers-modal",
  templateUrl: "./transfer-numbers-modal.component.html",
  styleUrls: ["./transfer-numbers-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TransferNumbersModalComponent implements OnInit {
  formControl = new FormControl();
  _pbxList: Array<Pbx> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { pbxes: Array<Pbx> },
    public dialogRef: MatDialogRef<TransferNumbersModalComponent>
  ) {
    this._pbxList = data.pbxes;
  }

  get pbxList(): Array<Pbx> {
    return this._pbxList;
  }

  submitData(): void {
    this.dialogRef.close(this.formControl.value);
  }

  ngOnInit(): void {
    this.formControl.setValue(this.pbxList[0]);
  }
}
